import { useTranslation } from 'react-i18next'
import {
  regulatoryNewsCategoryKey,
  type RegulatoryNewsCategory,
} from '@/shared/hooks/api/regulatoryNews'
import { Badge } from '@/components/ui/badge'
import { getRegulatoryNewsTopicDisplayLabel } from '../utils/regulatoryNewsTopicDisplay'

type MatchedCategoryChipsProps = {
  categories: RegulatoryNewsCategory[]
  label: string
}

export function MatchedCategoryChips({
  categories,
  label,
}: MatchedCategoryChipsProps) {
  const { t } = useTranslation('regulatory-alerts')

  if (categories.length === 0) {
    return null
  }

  return (
    <div className='space-y-2'>
      <p className='text-sm font-medium'>{label}</p>
      <div className='flex flex-wrap gap-2'>
        {categories.map((category) => (
          <Badge key={regulatoryNewsCategoryKey(category)} variant='secondary'>
            {getRegulatoryNewsTopicDisplayLabel(category, t)}
          </Badge>
        ))}
      </div>
    </div>
  )
}
